import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { UsersTaskConfig } from './shared/users-task-management.config.service';
import { UsersTaskDataService } from './shared/users-task-management.data.service';
import { DatePipe } from "@angular/common";
import { BaseControl } from '../dynamic-form';
import { ConfirmComponent } from '../confirm/confirm.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'iw-task-users-management',
  templateUrl: './users-task-management.component.html',
  styleUrls: ['./users-task-management.component.scss'],
  providers: [UsersTaskDataService]
})
export class UsersTaskComponent implements OnInit {
  //Tarea actual
  @Input() task_id: number;
// Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  // Contiene el responsable seleccionado
  userSelect: any;
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  //Configuración de la tabla
  settings = {}
  // Información de la tabla
  source: LocalDataSource;
  //Configuración de la tabla de usuarios
  settingsUsers = {}
  // Información de la tabla de usuarios
  sourceUsers: LocalDataSource;
  //Datos para llenar la tabla
  dataTable: any[] = [];
  // Filas seleccionadas de la tabla
  selectedRows: number[] = [];
  // usuarios seleccionados para agregar a la tarea
  selectedUsers: number[] = []
  // controla la carga de la tabla de responsables
  loading: boolean = false;
  // controla la carga de la tabla de usuarios para asignar
  loadingResponsible: boolean = false;
  //Emite la accion para refrescar el flujo
  @Output() validUsersUpdate: EventEmitter<boolean> = new EventEmitter();
  // Componente de confirmaciones
  @ViewChild(ConfirmComponent) private confirmRef: ConfirmComponent;

  

  constructor(
    private htds: UsersTaskDataService,
    private datePipe: DatePipe,
    private toastr: ToastrService,) { }

  ngOnInit() {
    this.selectedRows = [];
    this.selectedUsers = [];
    const userTaskConf = new UsersTaskConfig();
    this.settings = userTaskConf.settings;
    this.settingsUsers = userTaskConf.settingsUser;
    this.loading = true;
    this.htds.getUsers(this.task_id).then(res=>{
      if(res){
        this.source = new LocalDataSource(res);
        this.loading = false;
      }
    })
  }

  /**
   * Controla la seleccion de registros en la tabla de responsables
   *
   * @param {*} data
   * @memberof UsersTaskComponent
   */
  userRowSelect(data: any) {
    if(data && data.data){
    const existSelect = this.selectedRows.indexOf(data['data']['id']);
    if (existSelect > -1 && !data.isSelected) {
      this.selectedRows.splice(existSelect, 1);
    } else if(existSelect == -1 && data.isSelected) {
      this.selectedRows.push(data['data']['id']);
    }
    }else{
      if(data && data.selected.length){
        this.selectedRows = [];
        data.selected.forEach((element:any) => {
          this.selectedRows.push(element['id']);
      });
    }
    }
  }

  /**
   * Controla la seleccion de todos los registros de usaurios para asignar a la tarea
   *
   * @param {*} data
   * @memberof UsersTaskComponent
   */
  userAddRowSelect(data: any) {
    if(data && data.data){
      const existSelect = this.selectedUsers.indexOf(data['data']['id']);
      if (existSelect > -1 && !data.isSelected) {
        this.selectedUsers.splice(existSelect, 1);
      } else if(existSelect == -1 && data.isSelected) {
        this.selectedUsers.push(data['data']['id']);
      }
      }else{
        if(data && data.selected.length){
          this.selectedUsers = [];
          data.selected.forEach((element:any) => {
            this.selectedUsers.push(element['id']);
        });
      }
      }
  }


    /**
   * Condiciona acción ha realzar
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof UsersTaskComponent
   */
    defineActionCondictions(action: 'add' | 'delete' = 'add', data?: any) {
        switch (action) {
          case 'add':
              this.formOpen = true;
              this.loadingResponsible = true;
              this.htds.getTaskGroupUsers(this.task_id).then(res=>{
                if(res){
                  this.sourceUsers = new LocalDataSource(res);
                  this.loadingResponsible = false;
                }
              })
            break;
          case 'delete':
            if (this.selectedRows.length) {
              let question = '';
              if (this.selectedRows.length > 1) {
                question = '¿Realmente desea eliminar los usuarios seleccionados de la tarea?';
              } else {
                question = '¿Realmente desea eliminar el usuario de la tarea?';
              }
              this.confirmRef.new({
                question: question,
                labelConfirm: 'Sí',
                labelDecline: 'No'
              }).then(resp => {
                if (resp) {
                  this.htds.deleteUsersTask(this.task_id,this.selectedRows).subscribe(_res => {
                    this.selectedRows = [];
                    this.validUsersUpdate.emit(true);
                  },
                  _err => {
                  });
                }
                else{
                  
                }
              });
            } else {
              this.toastr.warning('Debe seleccionar al menos un usuario responsable.', 'Información incompleta.');
            }
            break;
        }
      }

    /**
     * Agrega los usuarios a la tarea como responsables
     *
     * @param {boolean} res
     * @memberof UsersTaskComponent
     */
    addUsersTask(){
      if(this.selectedUsers.length){
        let question = '';
        if (this.selectedUsers.length > 1) {
          question = '¿Desea asignar los usuarios seleccionados como responsables de la tarea?';
        } else {
          question = '¿Desea asignar el usuario seleccionado como responsable de la tarea?';
        }
        this.confirmRef.new({
          question: question,
          labelConfirm: 'Sí',
          labelDecline: 'No'
        }).then(resp => {
          if (resp) {
            this.htds.addUsersTask(this.task_id,this.selectedUsers).subscribe(_res => {
              this.selectedUsers = [];
              this.validUsersUpdate.emit(true);
            },
            _err => {
            });
          }
          else{
            
          }
        });
      }
      else {
        this.toastr.warning('Debe seleccionar al menos un usuario', 'Información incompleta.');
      }
    }

    closeForm(){
      this.formOpen = false;
      this.loadingResponsible = false;
      this.selectedUsers = [];
      this.selectedRows = [];
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/users-task-management/users-task-management.component.ts